import { render, staticRenderFns } from "./OrganizationViewOrganizationPlanCard.vue?vue&type=template&id=b99bf21a"
import script from "./OrganizationViewOrganizationPlanCard.vue?vue&type=script&lang=js"
export * from "./OrganizationViewOrganizationPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports